import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from "react-redux";
import configureStroe from "store/configureStore";
import { history } from "./history";
import { Router, Route, Switch } from "react-router-dom";
import indexRoutes from "routes/index";
import registerServiceWorker from './registerServiceWorker';

import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import MomentUtils from "@date-io/moment";

import { createMuiTheme } from "@material-ui/core/styles"
import { ThemeProvider } from "@material-ui/styles"

import "chartist/dist/chartist.min.css";

import './index.css';
import 'assets/css/material-dashboard-react.css?v=1.3.0';

import { initializeFirebase } from "utils/pushNotifications";

const store = configureStroe();
const theme = createMuiTheme();

MomentUtils.prototype.getStartOfMonth=MomentUtils.prototype.startOfMonth;

ReactDOM.render(
    <Provider store={store}>
        <MuiPickersUtilsProvider utils={MomentUtils}>
            <ThemeProvider theme={theme}>
                <Router history={history}>
                    <Switch>
                        {indexRoutes.map((prop, key) => {
                            return <Route path={prop.path} component={prop.component} exact={prop.exact} key={key} />;
                        })}
                    </Switch>
                </Router>
            </ThemeProvider>
        </MuiPickersUtilsProvider>
    </Provider>,
    document.getElementById('root'));
registerServiceWorker();
initializeFirebase();



// WEBPACK FOOTER //
// ./src/index.js